
import * as React from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ListItemText from '@mui/material/ListItemText';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { alertIcon, closeIcon, contractIcon, editProjectIcon, editWorkerIcon, entryIcon, equipmentIcon, homeIcon, logoutIcon, mainIcon, messageIcon, monitoringIcon, noNotificationIcon, notificationIcon, openIcon, pullDownButtonIcon, scheduleIcon, timeIcon, workIcon } from '../assets/imgs';
import { Avatar, Menu, MenuItem } from '@mui/material';
import { NavigationContainer, NavigationSideContainer } from '../assets/style';
import { useNavigate } from 'react-router-dom';
import {
    dashboardPageName,
    schedulePageName,
    realTimePageName,
    monitoringPageName,
    entryPageName,
    projectPageName,
    contractPageName,
    equipmentPageName,
    workPageName,
    workerPageName,
    alertPageName,
    companyPageName,
    internalReportPageName,
    reportPageName,
    userPageName,
} from './PageName';
import { GlobalStateContext } from '../store/GlobalState';
import { useDispatch, useSelector } from 'react-redux';
import { logOut, selectPermissions } from '../features/auth/authSlice';
import { useEffect, useState } from 'react';
import LogoutFunction from './LogoutFunction';
import useLogOut from './LogoutFunction';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import TranslateIcon from '@mui/icons-material/Translate';
import { useTranslation } from 'react-i18next';
import { Person } from '@mui/icons-material';
import { Permissions } from '../utils/Permissions'

const drawerWidth = 260;

const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

// const AppBar = styled(MuiAppBar, {
//     shouldForwardProp: (prop) => prop !== 'open',
// })<AppBarProps>(({ theme, open }) => ({
//     zIndex: theme.zIndex.drawer + 1,
//     transition: theme.transitions.create(['width', 'margin'], {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.leavingScreen,
//     }),
//     ...(open && {
//         marginLeft: drawerWidth,
//         width: `calc(100% - ${drawerWidth}px)`,
//         transition: theme.transitions.create(['width', 'margin'], {
//             easing: theme.transitions.easing.sharp,
//             duration: theme.transitions.duration.enteringScreen,
//         }),
//     }),
// }));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

// export default function SideBar() {
const MainContent = React.forwardRef<HTMLDivElement, { style?: React.CSSProperties; children: React.ReactNode; type: String }>((
    { style, children, type }, ref) => {
    const [open, setOpen] = React.useState(false);
    const [select, setSelect] = React.useState(type);
    const [notification, setNotification] = React.useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { logoutUser } = useLogOut();
    const handleDrawer = () => {
        setOpen(!open);
    };

    // useEffect(() => {
    //     // console.log("effect in main")
    //     const storedToken = localStorage.getItem('accessToken');
    //     if (storedToken == "") {
    //         navigate("/");
    //         return; // not needed to fetch data
    //     }
    //     globalState.setAccessToken(storedToken);

    //     if (globalState.token === "") {
    //         navigate("/");
    //         return; // not needed to fetch data
    //     }
    // }, [globalState.accessToken, localStorage.getItem('accessToken')]);

    const drawerItems: [string, JSX.Element, string, string[]][] = [
        [dashboardPageName, <img src={mainIcon} />, `/dashboard`, []],
        [schedulePageName, <img src={scheduleIcon} />, `/schedule`, []],
        // [realTimePageName, <img src={timeIcon} />, `/real-time`, []]
        // [monitoringPageName, <img src={monitoringIcon} />, `/safety-monitoring`, []],
        [entryPageName, <img src={entryIcon} />, `/entry`, ["EntryView"]],
        [projectPageName, <img src={editProjectIcon} />, `/project`, ["ProjectView"]],
        [contractPageName, <img src={contractIcon} />, `/contract`, ["ContractView"]],
        [equipmentPageName, <img src={equipmentIcon} />, `/equipment`, ["EquipmentView"]],
        // [workPageName, <img src={workIcon} />, `/work`, []],
        [workerPageName, <img src={editWorkerIcon} />, `/worker`, ["WorkerView"]],
        // [alertPageName, <img src={alertIcon} />, `/alert`, ["Admin"]],
        [companyPageName, <BusinessCenterIcon sx={{ color: 'white' }} />, `/company`, ["CompanyView"]],
        [reportPageName, <SummarizeIcon sx={{ color: 'white' }} />, `/report`, ["MonthlyReportView"]],
        [internalReportPageName, <SummarizeIcon sx={{ color: 'white' }} />, `/internal-report`, ["ReportView"]],
        [userPageName, <Person sx={{ color: 'white' }} />, `/user`, ["UserView"]],
    ]

    const permissions = useSelector(selectPermissions)

    const handleSideButtonClick = (text: any, path: string) => {
        setSelect(text);
        navigate(path)
    };

    const { t, i18n } = useTranslation();
    const TranslateIconClick = () => {
        i18n.changeLanguage(i18n.language == "en" ? "zh" : "en");
        localStorage.setItem("i18n", i18n.language);
        //console.log(i18n.language);
    }

    const username = localStorage.user.split("@")[0];

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const changePassword = function () {
        // alert("Coming soon.")
        navigate('/change-password')
        handleClose()
    }

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Drawer variant="permanent" open={open} PaperProps={{
                sx: {
                    backgroundColor: "#456296",
                    color: "white",
                    // minWidth: open ? "280px" : "80px"
                },
            }}>
                <div style={{ textAlign: "right" }}>
                    <IconButton onClick={handleDrawer}>
                        {!open ? <img src={openIcon} /> : <img src={closeIcon} />}
                    </IconButton>
                </div>
                <DrawerHeader sx={{ minHeight: 100 }}>
                    {/* <DrawerHeader sx={{ display: 'grid', gridTemplateRows: 'auto 1fr', minHeight: 200 }}> */}
                    {/* height: open ? 200 : 50 */}
                    {/* <div style={{ display: 'flex' }}> */}

                    <div style={{ paddingLeft: '12px' }}>
                        {open && (
                            <Typography
                                sx={{
                                    // fontFamily: 'Otomanopee One',
                                    fontSize: 28,
                                    fontWeight: 400,
                                    // minHeight: 400
                                    // fontWeight: 'bold',
                                }}
                            >
                                {t("Confined Space")} <br />{t("Program")}
                            </Typography>
                        )}
                    </div>
                    {/* </div> */}
                </DrawerHeader>
                &nbsp;
                {/* <Divider /> */}
                <List sx={{ maxHeight: 'calc(100vh - 100px)', minWidth: "260px" }}>
                    {drawerItems
                        .filter(([_, _2, _3, requiredPermissions]) => requiredPermissions.filter(p => !permissions.includes(p)).length == 0)
                        .map(([text, icon, path], index) => (
                            <ListItem key={text} disablePadding sx={{ display: 'block' }}>
                                <ListItemButton
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: open ? 'initial' : 'center',
                                        px: 2.5,
                                        backgroundColor: select == text ? "#8BB0DB" : "#325594",
                                        borderRadius: select == text ? '0 30px 30px 0px' : "",
                                        width: select == text ? '92%' : "100%",
                                    }}
                                    onClick={() => handleSideButtonClick(text, path)}
                                >

                                    <ListItemIcon
                                        sx={{
                                            minWidth: 20,
                                            mr: open ? 1 : 'auto',
                                            justifyContent: 'center',

                                        }}
                                    >
                                        {icon}
                                    </ListItemIcon>
                                    <ListItemText primary={t(text)} sx={{ opacity: open ? 1 : 0 }} />
                                    {select == text && open && <Avatar
                                        sx={{
                                            px: 1,
                                            mr: 0,
                                            justifyContent: 'center',
                                            width: 48, // Set the width of the Avatar
                                            height: 32, // Set the height of the Avatar
                                        }}
                                        src={logoutIcon} // Replace with your image URLs
                                        alt={text}
                                    />}
                                </ListItemButton>
                            </ListItem>
                        ))}
                </List>
                <Box sx={{ height: "40px" }}></Box>
                <Divider sx={{ backgroundColor: "white", width: "80%" }} />
                <Box sx={{ height: "10px" }}></Box>
                <List>
                    {[t('Logout')].map((text, index) => (
                        <ListItem key={text} disablePadding sx={{ display: 'block' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: open ? 'initial' : 'center',
                                    px: 2.5,
                                    backgroundColor: "#052A70",
                                    borderRadius: '0 25px 25px 0px', // Rectangle shape
                                    // borderWidth: '80%',
                                    width: '92%',
                                    overflow: 'hidden', // Ensure the half circle is visible
                                }}
                                onClick={() => logoutUser()}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: open ? 3 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <img src={logoutIcon} alt="" />
                                </ListItemIcon>
                                <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Drawer>

            <Box component="main" sx={{ flexGrow: 1, width: '90%', height: '100%' }}>
                <NavigationContainer>
                    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <NavigationSideContainer display="flex" sx={{ margin: "16px" }}>
                                <IconButton sx={{
                                    width: 35,
                                    height: 35,
                                    marginLeft: "5px",
                                }} onClick={() => { navigate('/schedule'); }}>
                                    <img src={homeIcon} />
                                </IconButton>
                                <IconButton sx={{
                                    width: 35,
                                    height: 35,
                                    marginLeft: "5px",
                                    color: "#7e8080"
                                }} onClick={() => TranslateIconClick()}>
                                    <TranslateIcon />
                                </IconButton>
                                <IconButton sx={{
                                    width: 35,
                                    height: 35,
                                    marginLeft: "5px",
                                }} >
                                    <img src={messageIcon} />
                                </IconButton>
                                {
                                    permissions.includes(Permissions.PersonalAlertView) &&
                                    <IconButton sx={{
                                        width: 35,
                                        height: 35,
                                        marginLeft: "5px",
                                    }} onClick={() => navigate('/alert-listing')}>
                                        {notification ? <img src={notificationIcon} /> : <img src={noNotificationIcon} />}
                                    </IconButton>
                                }
                                <IconButton sx={{
                                    width: 35,
                                    height: 35,
                                    marginLeft: "5px",
                                }} onClick={handleClick}>
                                    <SettingsOutlinedIcon />
                                </IconButton>
                                {/* <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ marginLeft: "12px" }}>{t("Hello, ")}</span>
                                    <span style={{ marginLeft: "12px", color: "grey" }}>{username}</span>
                                </Box> */}
                                <Box
                                    sx={{ display: 'flex', flexDirection: 'column' }}
                                    aria-controls="simple-menu"
                                    aria-haspopup="true"
                                // onClick={handleClick}
                                >
                                    <span style={{ marginLeft: "12px", color: "grey" }}>{t("Hello, ")}</span>
                                    <span style={{ marginLeft: "12px", color: "grey" }}>{username}</span>
                                </Box>
                                <Menu
                                    id="menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={changePassword}>Change Password</MenuItem>
                                </Menu>
                                {/* <IconButton sx={{ marginLeft: "12px" }}>
                                    <img src={pullDownButtonIcon} />
                                </IconButton> */}
                            </NavigationSideContainer>
                        </Box>
                    </Box>
                </NavigationContainer>
                {children}
            </Box>
        </Box >
    )
});
export default MainContent;